export default [
    { key: 'xs', width: 0 },
    { key: 'sm', width: 576 },
    { key: 'md', width: 768 },
    { key: 'lg', width: 992 },
    { key: 'xl', width: 1200 },
];
